import { useState } from 'react'

import { LOW_BUDGET_THRESHOLD } from './helpers'

interface UseLowBudgetAlertProps {
  campaignId?: number | string
  isViewsBasedModel: boolean
  valueSlider: number
}

interface UseLowBudgetAlertReturn {
  isLowBudgetVisible: boolean
  closeLowBudgetAlert: () => void
}

export const useLowBudgetAlert = ({
  campaignId,
  isViewsBasedModel,
  valueSlider,
}: UseLowBudgetAlertProps): UseLowBudgetAlertReturn => {
  const isLowBudget = valueSlider < LOW_BUDGET_THRESHOLD
  const isAlertActive = isViewsBasedModel && isLowBudget

  const [isLowBudgetDismissed, setIsLowBudgetDismissed] = useState(false)
  const [prevCampaignId, setPrevCampaignId] = useState(campaignId)
  const [prevIsAlertActive, setPrevIsAlertActive] = useState(isAlertActive)

  if (campaignId !== prevCampaignId) {
    setPrevCampaignId(campaignId)
    setIsLowBudgetDismissed(false)
  }

  if (isAlertActive !== prevIsAlertActive) {
    setPrevIsAlertActive(isAlertActive)
    if (!isAlertActive) {
      setIsLowBudgetDismissed(false)
    }
  }

  return {
    isLowBudgetVisible: isAlertActive && !isLowBudgetDismissed,
    closeLowBudgetAlert: () => setIsLowBudgetDismissed(true),
  }
}
